import { render, staticRenderFns } from "./VideoPlayer.vue?vue&type=template&id=0fe7ce08&scoped=true&"
import script from "./VideoPlayer.vue?vue&type=script&lang=js&"
export * from "./VideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlayer.vue?vue&type=style&index=0&id=0fe7ce08&prod&lang=css&"
import style1 from "./VideoPlayer.vue?vue&type=style&index=1&id=0fe7ce08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe7ce08",
  null
  
)

export default component.exports